// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "spa-assets/js/vendors/vue-router") return "spa-assets/js/vendors/vue-router-8f90c74e4a3ac267d782.js";
	if (chunkId === "sparta-install-temp_deposits_node_modules_sparta_global_vendors_jsencrypt_js_jsencrypt_js") return "spa-assets/js/common-chunks/sparta-install-temp_deposits_node_modules_sparta_global_vendors_jsencrypt_js_jsencrypt_js-7cf560c94a3a1420171a.js";
	// return url for filenames based on template
	return undefined;
};